import React from 'react';

export default function WarningIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M20 36.6663C29.2047 36.6663 36.6666 29.2044 36.6666 19.9997C36.6666 10.7949 29.2047 3.33301 20 3.33301C10.7952 3.33301 3.33331 10.7949 3.33331 19.9997C3.33331 29.2044 10.7952 36.6663 20 36.6663Z"
        fill="#E56910"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.9997 22.5C19.2633 22.5 18.6663 21.903 18.6663 21.1667L18.6663 12C18.6663 11.2636 19.2633 10.6667 19.9997 10.6667C20.7361 10.6667 21.333 11.2636 21.333 12L21.333 21.1667C21.333 21.903 20.7361 22.5 19.9997 22.5Z"
        fill="white"
      />
      <circle cx="20" cy="27.0837" r="2.08333" transform="rotate(-180 20 27.0837)" fill="white" />
    </svg>
  );
}
